import { appConfigurationFragment } from "@saleor/fragments/appConfiguration";
import { appConfigErrorFragment } from "@saleor/fragments/errors";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  AppConfigCreate,
  AppConfigCreateVariables
} from "./types/AppConfigCreate";
import {
  AppConfigUpdate,
  AppConfigUpdateVariables
} from "./types/AppConfigUpdate";

const appConfigCreate = gql`
  ${appConfigErrorFragment}
  ${appConfigurationFragment}
  mutation AppConfigCreate($name: String!, $json: Upload!) {
    appConfigCreate(input: { name: $name, json: $json }) {
      errors: appconfigError {
        ...AppConfigErrorFragment
      }
      appConfig {
        ...AppConfigurationFragment
      }
    }
  }
`;

export const useAppConfigCreate = makeMutation<
  AppConfigCreate,
  AppConfigCreateVariables
>(appConfigCreate);

const appConfigUpdate = gql`
  ${appConfigErrorFragment}
  ${appConfigurationFragment}
  mutation AppConfigUpdate($json: Upload!, $id: ID!) {
    appConfigUpdate(json: $json, id: $id) {
      errors: appconfigError {
        ...AppConfigErrorFragment
      }
      appConfig {
        ...AppConfigurationFragment
      }
    }
  }
`;
export const useAppConfigUpdate = makeMutation<
  AppConfigUpdate,
  AppConfigUpdateVariables
>(appConfigUpdate);
